<div class="filter-for-list">
  <h3   class="alarm-project-name">{{'LAST_ALARM_TOOLTIP' | translate}}</h3>
  <app-project-sub-menu></app-project-sub-menu>
  <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
    <input matInput (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
  </mat-form-field>

  <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner"></app-progressbar>
<table mat-table [dataSource]="matTableDataSource" matSort class="table-striped" style="width:100%" matSortActive="time"
       matSortDirection="desc">

  <ng-container matColumnDef="projectName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PROJECT'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">
      <mat-chip-list>
        <mat-chip class="project"> {{alarm.projectName}}
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="time">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'DATE'|translate}}</th>
    <td mat-cell *matCellDef="let alarm"> {{alarm.time}}</td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'TYPE'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">
      <mat-chip class="type">{{alarm.type}}
      </mat-chip>
    </td>
  </ng-container>

  <ng-container matColumnDef="deviceType">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'DEVICE'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">
      <mat-chip-list>
        <mat-chip class="project"> {{alarm.deviceType}}
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="threshold">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'THRESHOLD'|translate}}</th>
    <td mat-cell *matCellDef="let alarm"> {{alarm.threshold}}</td>
  </ng-container>

  <ng-container matColumnDef="locationName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LOCATION'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">
      <mat-chip-list>
        <mat-chip class="selected"> {{alarm.locationName}}
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">
      <button type="button" class="btn list-tools" style="background: cornflowerblue"
              (click)="navigateToChart(alarm.locationId,alarm.time)" placement="left"
              [ngbTooltip]="'CHART_TOOLTIP' | translate">
        <fa-icon [icon]="iconService.faChartLine"></fa-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>
<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="pageSize"></mat-paginator>



